import { Label } from "@/components/ui/label";
import { Link, useParams } from "react-router";
import { featureTypeUrlBuilder, featureUrlBuilder } from "@/lib/url-builder";

interface FeatureFooterProps {
  featureId: string | null;
  featureTypeId: string | null;
  featureName: string | null;
  featureTypeName: string | null;
}

const FeatureFooter: React.FC<FeatureFooterProps> = ({ featureId, featureTypeId, featureName, featureTypeName }) => {
  const params = useParams();

  return (
    <>
      <div className="flex gap-1 items-center">
        <Label>Feature</Label>
        {featureId ? (
          <Link
            className="text-sm text-blue-500"
            to={featureUrlBuilder(params.tenantId!, params.siteId!, featureId!)}
          >
            {featureName}
          </Link>
        ) : (
          "N/A"
        )}
      </div>
      <div className="flex gap-1 items-center">
        <Label>Feature Type</Label>
        {featureTypeId ? (
          <Link
            className="text-sm text-blue-500"
            to={featureTypeUrlBuilder(params.tenantId!, params.siteId!, featureTypeId!)}
          >
            {featureTypeName}
          </Link>
        ) : (
          "N/A"
        )}
      </div>
    </>
  );
};

export default FeatureFooter;
